/* Haneul — scripts propios (prefijo hn-) */
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initReveal() {
    var els = document.querySelectorAll('.hn-reveal:not(.hn-visible)');
    if (!els.length) return;
    if (reduce || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('hn-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('hn-visible'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  function initParallax() {
    var els = document.querySelectorAll('[data-hn-parallax]');
    if (!els.length || reduce) return;
    var ticking = false;
    function update() {
      els.forEach(function (el) {
        var f = parseFloat(el.getAttribute('data-hn-parallax')) || 0;
        var r = el.getBoundingClientRect();
        var off = (r.top + r.height / 2 - window.innerHeight / 2) * f * -0.01;
        el.style.translate = '0 ' + off.toFixed(1) + 'px';
      });
      ticking = false;
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { requestAnimationFrame(update); ticking = true; }
    }, { passive: true });
    update();
  }

  function initDiagnostico() {
    document.querySelectorAll('[data-hn-diag]').forEach(function (root) {
      if (root.dataset.hnListo) return;
      root.dataset.hnListo = '1';
      var tabs = root.querySelectorAll('[role="tab"]');
      var panels = root.querySelectorAll('[role="tabpanel"]');
      tabs.forEach(function (tab, i) {
        tab.addEventListener('click', function () {
          tabs.forEach(function (t) { t.setAttribute('aria-selected', 'false'); t.tabIndex = -1; });
          panels.forEach(function (p) { p.classList.remove('is-activo'); });
          tab.setAttribute('aria-selected', 'true'); tab.tabIndex = 0;
          if (panels[i]) panels[i].classList.add('is-activo');
        });
        tab.addEventListener('keydown', function (e) {
          var n = null;
          if (e.key === 'ArrowRight') n = tabs[(i + 1) % tabs.length];
          if (e.key === 'ArrowLeft') n = tabs[(i - 1 + tabs.length) % tabs.length];
          if (n) { n.focus(); n.click(); }
        });
      });
    });
  }

  function initProducto() {
    document.querySelectorAll('[data-hn-producto]').forEach(function (root) {
      if (root.dataset.hnListo) return;
      root.dataset.hnListo = '1';

      // Galería
      var principal = root.querySelector('[data-hn-principal]');
      root.querySelectorAll('[data-hn-mini]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          root.querySelectorAll('[data-hn-mini]').forEach(function (b) { b.classList.remove('is-activa'); });
          btn.classList.add('is-activa');
          if (principal) {
            var img = document.createElement('img');
            img.src = btn.getAttribute('data-src');
            img.srcset = btn.getAttribute('data-srcset') || '';
            img.sizes = '(max-width: 990px) 100vw, 55vw';
            img.alt = btn.getAttribute('data-alt') || '';
            principal.innerHTML = '';
            principal.appendChild(img);
          }
        });
      });

      // Cantidad
      var qty = root.querySelector('[data-hn-qty]');
      root.querySelectorAll('[data-hn-qty-btn]').forEach(function (b) {
        b.addEventListener('click', function () {
          var v = parseInt(qty.value, 10) || 1;
          v += parseInt(b.getAttribute('data-hn-qty-btn'), 10);
          qty.value = Math.max(1, v);
        });
      });

      // Variantes
      var dataEl = root.querySelector('[data-hn-variantes]');
      var form = root.querySelector('form[action*="/cart/add"]');
      var boton = root.querySelector('[data-hn-add]');
      var precioEl = root.querySelector('[data-hn-precio]');
      var idInput = form ? form.querySelector('input[name="id"]') : null;
      var variantes = [];
      try { variantes = JSON.parse(dataEl ? dataEl.textContent : '[]'); } catch (e) {}
      var formato = root.getAttribute('data-hn-moneda') || '';
      var txtAdd = boton ? boton.getAttribute('data-txt-add') : '';
      var txtAgotado = boton ? boton.getAttribute('data-txt-agotado') : '';

      function money(cents) {
        var n = (cents / 100);
        var entero = Math.round(n).toLocaleString('es-CL');
        var dec = n.toLocaleString('es-CL', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
        if (formato.indexOf('{{') === -1) return '$' + entero;
        return formato
          .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, entero)
          .replace(/\{\{\s*amount_no_decimals\s*\}\}/, entero.replace(/\./g, ','))
          .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, dec)
          .replace(/\{\{\s*amount\s*\}\}/, n.toLocaleString('en-US', { minimumFractionDigits: 2 }));
      }

      function actualizar() {
        if (!variantes.length) return;
        var sel = [];
        root.querySelectorAll('[data-hn-opcion]').forEach(function (fs) {
          var c = fs.querySelector('input:checked');
          sel.push(c ? c.value : null);
        });
        var v = variantes.find(function (x) {
          return x.options.every(function (o, i) { return o === sel[i]; });
        });
        if (!v) {
          if (boton) { boton.disabled = true; boton.querySelector('span').textContent = txtAgotado; }
          return;
        }
        if (idInput) idInput.value = v.id;
        if (precioEl) {
          var html = '<span>' + money(v.price) + '</span>';
          if (v.compare_at_price && v.compare_at_price > v.price) html += '<s>' + money(v.compare_at_price) + '</s>';
          precioEl.innerHTML = html;
        }
        if (boton) {
          boton.disabled = !v.available;
          boton.querySelector('span').textContent = v.available ? txtAdd : txtAgotado;
        }
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      }
      root.querySelectorAll('[data-hn-opcion] input').forEach(function (inp) {
        inp.addEventListener('change', actualizar);
      });

      // Añadir al carrito con el cajón de Dawn si existe
      if (form) {
        form.addEventListener('submit', function (e) {
          var drawer = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
          if (!drawer || typeof drawer.renderContents !== 'function' || !window.fetch) return;
          e.preventDefault();
          var aviso = root.querySelector('[data-hn-aviso]');
          if (aviso) aviso.textContent = '';
          boton.disabled = true;
          var fd = new FormData(form);
          var secciones = drawer.getSectionsToRender().map(function (s) { return s.id; });
          fd.append('sections', secciones);
          fd.append('sections_url', window.location.pathname);
          fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', {
            method: 'POST', body: fd, headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' }
          })
            .then(function (r) { return r.json(); })
            .then(function (res) {
              if (res.status) {
                if (aviso) aviso.textContent = res.description || res.message || 'No se pudo añadir.';
                return;
              }
              drawer.renderContents(res);
              if (drawer.classList.contains('is-empty')) drawer.classList.remove('is-empty');
            })
            .catch(function () { form.submit(); })
            .finally(function () { boton.disabled = false; });
        });
      }

      // Barra fija en móvil
      var barra = root.querySelector('[data-hn-barra]');
      if (barra && boton && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (en) {
          barra.classList.toggle('is-visible', !en[0].isIntersecting && en[0].boundingClientRect.top < 0);
        }).observe(boton);
        barra.querySelector('button').addEventListener('click', function () {
          boton.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' });
        });
      }
    });
  }

  function initAll() { initReveal(); initParallax(); initDiagnostico(); initProducto(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
  document.addEventListener('shopify:section:load', initAll);
})();
